export default "__VITE_ASSET__BzouP7h7__"